import type { DefaultValues } from 'react-hook-form';
import { array, boolean, number, object, string, type InferType } from 'yup';
import { fileSchema } from '../file/schema';
import { subtitleRemovalModeSchema } from '../video/subtitle-removal-mode';

export const schema = object({
  removal_mode: subtitleRemovalModeSchema,
  video_file: fileSchema.min(1, '请上传一个视频').required(),
  remove_subtitles: boolean().nullable().default(false),
  regenerate_subtitles: boolean().nullable().default(false),
  regenerate_voice: boolean().nullable().default(false),
  target_languages: array()
    .of(string().trim().required('请选择语种'))
    .meta({ select: true })
    .min(1)
    .max(10)
    .required(),
  long_video_source_language: string().when('is_long_video', {
    is: true,
    then: (s) => s.required(),
  }),
  long_video_voice: number()
    .nullable()
    .when('is_long_video', {
      is: true,
      then: (s) => s.required(),
    }),
});

export type DefaultVideoTranslationFormValues = DefaultValues<
  InferType<typeof schema>
>;
